import React, { useEffect } from 'react';
import { IMInputText, IMSelect, PageFooter } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { useRFQInitiationPageStore } from 'store/pages/rfq/initiate-rfq/rfq-initiation/pageStore';
import ContentCard from 'components/common/general/layouts/ContentCard';
import SectionTitle from 'components/common/general/SectionTitle';
import { RFQ_INITIATION_FORM_ID, RFQ_INITIATION_FORM_TEST_ID } from './constants';
import { IMFormStyled, IMZipCodeFieldStyled, IMZipStateFieldStyled, IMZipCountyFieldStyled } from './styles';

const InitiateRFQContent: React.FC = observer(() => {
  const {
    isInitialDataLoading,
    isActionLoading,
    proposalInfoForm,
    effectiveDatesOptions,
    canCompleteStep,
    redirectToChecklist,
    getInitialData,
    saveProposal,
  } = useRFQInitiationPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <>
      <ContentCard loading={isInitialDataLoading || isActionLoading}>
        <IMFormStyled
          id={RFQ_INITIATION_FORM_ID}
          formController={proposalInfoForm}
          data-test-id={RFQ_INITIATION_FORM_TEST_ID}
        >
          <SectionTitle title="Basic Information" />
          <IMInputText label="Proposal Name" name="proposalName" size="full" />
          <IMSelect label="Effective Date" name="effectiveDate" size="full" options={effectiveDatesOptions} disabled />
          <IMZipCodeFieldStyled size="s" disabled />
          <IMZipStateFieldStyled size="s" disabled />
          <IMZipCountyFieldStyled size="s" disabled />
          <IMInputText label="Response Due Date" name="responseDueDate" size="full" htmlType="date" />
        </IMFormStyled>
      </ContentCard>
      <PageFooter
        completeButtonText="Save"
        disableCompleteButton={!canCompleteStep}
        onComplete={saveProposal}
        onBack={redirectToChecklist}
      />
    </>
  );
});

export default InitiateRFQContent;
